export class FeatureFlagOverrideGet200Response {
    'flagKey';
    'value';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "flagKey",
            "baseName": "flagKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FeatureFlagOverrideGet200Response.attributeTypeMap;
    }
    constructor() {
    }
}
